import React from 'react';

export const BOOKED_BUTTON = {
	text: 'Booked',
	icon: 'check-circle-filled',
};

export const UNBOOKED_BUTTON = {
	text: 'Booked?',
	icon: 'check-circle',
};

export const BOOKED_MODAL = {
	title: 'Unmark as booked?',
	getText: (vendorName: string) => (
		<>
			<span>{vendorName}</span> will stay in your favorites but will no longer
			be marked as booked.
		</>
	),
	confirmButtonText: 'Unmark as booked',
	cancelButtonText: 'Keep as booked',
};

export const UNBOOKED_MODAL = {
	title: 'Mark as booked?',
	getText: (vendorName: string, categoryName: string) => (
		<>
			<span>{vendorName}</span> will be saved to your favorites as your booked{' '}
			{categoryName}.
		</>
	),
	confirmButtonText: 'Mark as booked',
	cancelButtonText: 'Not yet, just save',
	foundOnTKText: 'Did The Knot help you find this vendor?',
};

export const FAVORITE_UNBOOKED_MODAL = {
	title: 'Mark as booked?',
	getText: (vendorName: string, categoryName: string) => (
		<>
			<span>{vendorName}</span> will be saved to your booked {categoryName}.
		</>
	),
	confirmButtonText: 'Mark as booked',
	cancelButtonText: 'Not yet',
	foundOnTKText: 'Did The Knot help you find this vendor?',
};
